
import Transformer from '@/transformers/transformer'
import utilFormData from '@/utils/objectToForm'
import { assetURL } from '@/utils'

export default class ComplementTransformer extends Transformer {
  static send(complememt) {
   return utilFormData(complememt) 
  }

  static fetch({ id, uuid, xml_proof_payment, pdf_proof_payment,
                 amount, serie, folio, cfdi_type, date, subtotal,
                 total, exchange_rate, way_to_pay, add_date, tax_receipt,
                 sender, receiver, currency, warning }) {

    return {
      id, uuid, amount: +amount, serie, folio,
      cfdiType: cfdi_type,
      xmlProofPayment: assetURL(xml_proof_payment),
      pdfProofPayment: assetURL(pdf_proof_payment),
      date, subtotal, total,
      exchangeRate: exchange_rate, wayToPay: way_to_pay,
      addDate: add_date,
      taxReceipts: tax_receipt,
      sender, receiver, currency,
      warning,
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/taxReceipt/complement.js